export const SMART_FIELDS_MARKER = '{';
